import React from 'react';

import LoadingGif from "../../assets/gif/loading.svg";

function Loading() {
    return (
        <div
            className="w-[100vw] h-[100vh] fixed top-0 left-0 flex items-center justify-center"
            style={{
                zIndex: 1000,
                background: "rgba(0, 0, 0, 0.5)"
            }}
        >
            <img src={LoadingGif} alt="DODEAL" className="w-[200px] h-[200px]" />
        </div>
    );
}

export default Loading;
